export default function CtaSection() {
  return (
    <section className="py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 rounded-lg overflow-hidden shadow-lg">
          {/* Left Side - Image */}
          <div className="relative min-h-[300px] sm:min-h-[400px]">
            <img
              src="https://public.readdy.ai/ai/img_res/cc8e1c1c7da6f21b370ec7b75c2615de.jpg"
              alt="Espacio restaurado"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-bg/80 to-transparent"></div>
            <div className="absolute top-6 sm:top-8 left-6 sm:left-8">
              <span className="text-secondary font-sans text-xs sm:text-sm font-semibold">/contacto</span>
              <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-white mb-6 break-words">
                ¿Necesitas ayuda ahora?
              </h2>
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="bg-white p-8 sm:p-12 flex flex-col justify-center">
            <h3 className="font-sans font-bold text-2xl sm:text-3xl text-primary mb-6">
              Hablemos de Tu Caso
            </h3>
            <p className="text-textLight text-sm sm:text-base leading-relaxed mb-8 max-w-md">
              Cada incendio es diferente. Cuéntanos qué ha pasado y te orientamos sin compromiso. Respuesta en menos de 2 horas en horario laboral.
            </p>
            
            <div className="space-y-4">
              <a
                href="https://wa.me/34690220944"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-primary text-white px-6 sm:px-8 py-4 rounded-full font-sans font-semibold text-center hover:bg-opacity-90 transition-all cursor-pointer group"
              >
                Contactar por WhatsApp
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
              </a>
              
              <p className="text-textLight text-xs sm:text-sm text-center">
                O llama al{' '}
                <a href="tel:+34690220944" className="text-secondary font-semibold hover:text-primary cursor-pointer">
                  +34 690 22 09 44
                </a>
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200">
              <p className="text-textLight text-xs sm:text-sm mb-4">También puedes:</p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/servicios"
                  className="text-secondary text-xs sm:text-sm font-semibold hover:text-primary transition-colors cursor-pointer"
                >
                  Ver Servicios →
                </a>
                <a
                  href="/faq"
                  className="text-secondary text-xs sm:text-sm font-semibold hover:text-primary transition-colors cursor-pointer"
                >
                  Leer FAQ →
                </a>
                <a
                  href="/contacto"
                  className="text-secondary text-xs sm:text-sm font-semibold hover:text-primary transition-colors cursor-pointer"
                >
                  Formulario →
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Links */}
        <div className="mt-12 text-center">
          <p className="text-white/80 mb-4">¿Quieres saber más antes de contactar?</p>
          <div className="flex flex-wrap justify-center gap-6">
            <a
              href="/servicios"
              className="text-white font-sans font-semibold hover:text-secondary transition-colors cursor-pointer"
            >
              Conoce nuestros servicios →
            </a>
            <a
              href="/empresa"
              className="text-white font-sans font-semibold hover:text-secondary transition-colors cursor-pointer"
            >
              Sobre nosotros →
            </a>
            <a
              href="/faq"
              className="text-white font-sans font-semibold hover:text-secondary transition-colors cursor-pointer"
            >
              Preguntas frecuentes →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}